import { FC } from 'react';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import { Box, Typography } from '@mui/material';
import { CHECK_COPY } from '../ReportDialog.constants';
import { ValidateTabProps } from '../ReportDialog.props';
import { reportDialogColors as colors } from '../ReportDialog.styles';
import { formatFailedCompany } from '../ReportDialog.utils';
import SourceTable from '../SourceTable';

const ValidateTab: FC<ValidateTabProps> = ({ checks = [], sourceRows }) => (
  <Box data-testid="daily-nav-report-validate">
    {checks.map(check => {
      const { passed } = check;
      return (
        <Box
          key={check.key}
          data-testid={`daily-nav-validation-${check.key}`}
          sx={{
            alignItems: 'flex-start',
            bgcolor: passed ? colors.passWash : colors.failWash,
            borderRadius: 1.5,
            display: 'flex',
            gap: 1.25,
            mb: 1,
            px: 1.5,
            py: 1.25,
          }}>
          <Box
            sx={{
              alignItems: 'center',
              bgcolor: passed ? colors.pass : colors.fail,
              borderRadius: '50%',
              color: 'common.white',
              display: 'flex',
              flexShrink: 0,
              height: 22,
              justifyContent: 'center',
              mt: 0.15,
              width: 22,
            }}>
            {passed ? <Check sx={{ fontSize: 16 }} /> : <Close sx={{ fontSize: 16 }} />}
          </Box>
          <Box>
            <Typography sx={{ color: colors.ink, fontSize: 14, fontWeight: 600, lineHeight: 1.4 }}>
              {CHECK_COPY[check.key] ?? check.key}
            </Typography>
            {!passed && check.companies.length > 0 && (
              <Typography sx={{ color: colors.inkSoft, fontSize: 12, lineHeight: 1.5, mt: 0.5 }}>
                {check.companies.map(company => formatFailedCompany(company, sourceRows)).join('; ')}
              </Typography>
            )}
          </Box>
        </Box>
      );
    })}

    <Typography
      sx={{
        color: colors.inkSoft,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 0.2,
        mb: 1,
        mt: 2.5,
      }}>
      What was validated
    </Typography>
    <SourceTable rows={sourceRows} />
  </Box>
);

export default ValidateTab;
